import { DocumentPartTreeSelection } from "../DocumentPartTree";
import { cloneDocumentPartAsync } from "../../../redux/feature/document/document-slice";
import { EVENT_CHANNEL_DEFAULT_TOPIC } from "../../../utils/constants/eventChannel";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks/hooks";
import {
  selectBackendUrl,
  selectClientId,
  selectCpmUsername,
  selectTenantId,
} from "../../../redux/feature/settings/configurations-slice";
import { fetchDocumentMetadata } from "../../../api/document/DocumentsPart";

function getDocumentNameSuffix(): string {
  // Format date to => YYYY-MM-DDTHHMMSS
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0"); // months are 0-indexed
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}${minutes}${seconds}`;
}

export function useCloneDocPart(idPartRoot: string) {
  const username = useAppSelector(selectCpmUsername); // TEMP waiting for real login
  const backendUrl = useAppSelector(selectBackendUrl);
  const tenantId = useAppSelector(selectTenantId);
  const clientId = useAppSelector(selectClientId);
  const dispatch = useAppDispatch();

  async function cloneDocPart(docPartToClone: DocumentPartTreeSelection) {
    const documentMetadata = await fetchDocumentMetadata(docPartToClone.key);

    // const date = new Date().toLocaleString("it-IT");
    // const formattedDateTime = date.replace(/(\d{4})\/(\d{2})\/(\d{2}), (\d{2}):(\d{2}):(\d{2})/, "$3-$2-$1T$4$5$6"); // Format date to => YYYY-MM-DDTHHMMSS

    await cloneDocumentPartAsync({
      documentId: docPartToClone.key,
      partOrder: docPartToClone.data.order,
      fatherDocumentId: idPartRoot,
      channelIdToNotify: idPartRoot ?? EVENT_CHANNEL_DEFAULT_TOPIC,
      username,
      tenantId,
      dispatch,
      backendUrl,
      documentPartMetadata: null,
      documentName: docPartToClone.data.data.documentPart.name,
      documentNameSuffix: `_${getDocumentNameSuffix()}`,
      clientId,
      language: documentMetadata.language,
      templateInfo: documentMetadata.templateInfo,
      locale: documentMetadata.formatMetadata?.locale,
    });
  }

  return {
    cloneDocPart,
  };
}
